import React, { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import { MentionsInput, Mention } from 'react-mentions'
import defaultStyle from './defaultStyle';
import defaultMentionStyle from './defaultMentionStyle';
import { Button, Modal } from '../..';
import { ModalCloseButton } from '../../../icons';

export const ChangeMessageModal = (props) => {
  const { isVisible, onCancel, onSave, text } = props;

  const [value, setValue] = useState('');

  const onConfirm = () => {
    onSave(value);
  }

  useEffect(() => {
    setValue(text);
  }, [text])

  return (
    <Modal isVisible={isVisible} onClose={onCancel} width='640px' background="white">
      <div className="mt-5 px-5 flex items-center justify-between">
        <Title>Change Message</Title>
        <ModalCloseButton onClose={onCancel} />
      </div>
      <div className="mt-5 px-5">
        <MentionsInput
          value={value}
          onChange={event => setValue(event.target.value)}
          style={defaultStyle}
          placeholder={"Type here or use @ to mention someone"}
        >
          <Mention trigger='@' data={[]} style={defaultMentionStyle} />
        </MentionsInput>
      </div>
      <ButtonsWrapper className="mt-6">
        <Button
          title="Cancel"
          onClick={onCancel}
          type='outlined'
          big
        />
        <Button
          title="Save"
          onClick={onConfirm}
          big
        />
      </ButtonsWrapper>
    </Modal>
  )
}

const Title = styled.div`
  font-size: 24px;
  line-height: 29px;
  color: #000000;
`;

const ButtonsWrapper = styled.div`
  height: 80px;
  width: 100%;
  border-radius: 0px 0px 20px 20px;
  background-color: #F4FCF8;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
`;